import React from 'react';
import { useParams } from 'react-router-dom';
import RecruitmentPlanJobList from './RecruitmentPlanJobList';

const RecruitmentPlanJobExecList = () => {

    const { planIdParam } = useParams();

    return (
        <RecruitmentPlanJobList recuitmentPlanId={planIdParam} type="EXECUTIE"/>
    );
};

export default RecruitmentPlanJobExecList;
